








import { Component, Vue } from 'vue-property-decorator';
import { WALLET_SETTINGS_URL } from "./assets/js/urls";
import MyLoading from './components/MyLoading.vue';
const Cookies = require("js-cookie");
const axios = require("./axios/index.js").default;

@Component({
  components: {
    MyLoading,
  }
})
export default class App extends Vue {
  isShow: boolean = false;

  created() {
    this.$bus.$on('get-config', () => {
      this.getConfig();
    });

    this.$bus.$on('show-loading', (flag:boolean) => {
      this.isShow = flag;
    });
  }

  mounted() {
    let self: any = this;
    
    self.init();
  }

  init() {
    let self: any = this;
    let info: any = "";
    let sMsg: any = {
      action: 'getInfo',
      msg: ''
    }

    let hasBridge = (window as any).WebViewJavascriptBridge ? true : false;

    if(hasBridge) {
      self.$JBH.sendMsg(JSON.stringify(sMsg), (res: any) => {


        if (res) {
          if (typeof res === "string") {
            info = JSON.parse(res);
          } else {
            info = res;
          }

          if (info.ref_token) {
            info.flag = true;
            self.$store.dispatch("setLogin", info);

            self.$store.dispatch("setAvatar", info.ref_pic || '');
            self.$store.dispatch("setUsername", info.ref_name || '');

            self.getConfig();
          } else {
            info.flag = false;
            self.$store.dispatch("setLogin", info);
            self.$store.dispatch("setAvatar", "");
            self.$store.dispatch("setUsername", "");
          }
        }
      });
    }else{
      setTimeout(() => {

        self.init();
      }, 300);
    }
  }

  getConfig() {
      let self = this;

      self.$bus.$emit('show-loading', true);
      axios
        .post(WALLET_SETTINGS_URL, {})
        .then((resp: any) => {

          let resData = resp.data;
          self.$bus.$emit('show-loading', false);
          if (resData.status.code == 0) {
            self.$store.dispatch("setInviteCode", resData.result.user.refCode);
            self.$store.dispatch("setBalance", resData.result.wallet.amount);
            self.$store.dispatch("setCurrency", resData.result.wallet.currency || '');
            self.$store.dispatch("setAvatar", resData.result.user.picUrl || '');
            self.$store.dispatch("setUsername", resData.result.user.name || '');

            self.$store.dispatch("setWithdrawData", resData.result.withdraw);
          }else{
            self.$store.dispatch("setInviteCode", '');
            self.$store.dispatch("setBalance", 0);
            self.$store.dispatch("setCurrency", '');
            self.$store.dispatch("setAvatar", '');
            self.$store.dispatch("setUsername", '');
          }
        })
        .catch((e: any) => {
          self.$toasted.show(e);
          self.$bus.$emit('show-loading', false);
        });
  }
}
